import React from 'react';
import './LIRC.css';

const LIRC = () => {
  return (
    <div className="lirc-wrapper">
      <div className="lirc-image">
        <img
          src="https://images.unsplash.com/photo-1581092568395-d68050c2ab43?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTI4fHxzb2Z0d2FyZXxlbnwwfHwwfHx8Mg%3D%3D"
          alt="Job Opportunities"
        />
      </div>
      <div className="lirc-content">
        <p>
          At <b>V Adithya Infinity Pvt. Ltd.</b>, we bridge the gap between job seekers, students, freshers, freelancers, and recruiters. 
          With the growing demand for skilled professionals across IT and Non-IT domains, we create opportunities tailored to your career aspirations.
        </p>
        <p>
          Whether you're looking for your first job, exploring freelance or remote work, or seeking the right talent for your organization, 
          we provide end-to-end career solutions and guidance to help you succeed.
        </p>
      </div>
    </div>
  );
};

export default LIRC;
